import { Component } from '@angular/core';

@Component({
    selector: 'bl-politica-privacidade',
    templateUrl: './politica-privacidade.component.html',
    styleUrls: ['./politica-privacidade.component.scss'],
    standalone: false
})
export class PoliticaPrivacidadeComponent {}
